import React, { useState } from 'react';
import './text-field.scss';
// import { icons } from '@assets/icons/index';
import ImageComponent from '../image-component';
import { Link } from 'react-router-dom';
import EdenredTypo from '../typography/index';

const Input = ({
	labels = '',
	placeholder = ' ',
	edit = '',
	onChange,
	value = '',
	icon,
	type,
	link,
	disabled,
	validation = false,
	onPasswordChange,
	className = '',
	labelClassName = '',
	countryCode = false,
	countryCodeClassName,
	name,
	pattern,
	minDate,
	maxDate,
	maxLength,
	onBlur,
	onKeyDown,
}) => {
	const [hide, setHide] = useState(false);
	const [editDisabled, setEditDisabled] = useState(true);

	const handlePasswordChange = (event) => {
		onPasswordChange(event.target.value);
	};

	const toggleShow = () => {
		setHide(!hide);
	};

	const handleEditOption = () => {
		setEditDisabled(false);
	};
	const dummyFn = () => {
		console.log('d23456');
	};

	const FloatingInput = () => {
		return (
			<div className="floating-label">
				<input
					type={link ? (hide ? type : 'text') : type}
					// required
					onBlur={onBlur}
					maxLength={maxLength}
					value={value}
					max={maxDate ? maxDate : '9999-12-31'}
					min={minDate && minDate}
					onChange={onPasswordChange ? handlePasswordChange : onChange}
					placeholder={placeholder}
					disabled={editDisabled && disabled}
					name={name}
					className={`floating-input${className ? ' ' + className : ''}`}
					pattern={pattern}
					onKeyDown={onKeyDown}
				/>
				{/* src={icons.not_focus.Edit} */}
				{edit && <ImageComponent className="input_img" onClick={handleEditOption} />}
				{icon ? <div className="input_img"> {icon} </div> : null}
				{link ? (
					hide ? (
						<EdenredTypo medium b3 onClick={toggleShow} className="link_text">
							Show
						</EdenredTypo>
					) : (
						<EdenredTypo medium b3 onClick={toggleShow} className="link_text">
							Hide
						</EdenredTypo>
					)
				) : null}
				{labels && <label className={`form-field__label${labelClassName ? ' ' + labelClassName : ''}`}>{labels}</label>}
			</div>
		);
	};

	return !countryCode ? (
		FloatingInput()
	) : (
		<div className={`${countryCodeClassName}`}>
			<ImageComponent src={countryCode.icon} />
			<EdenredTypo>{countryCode.code}</EdenredTypo>
			{FloatingInput()}
		</div>
	);
};

export default Input;
